import PropTypes from "prop-types";
import React, { useRef } from "react";
import { useHistory } from "react-router-dom";

import FillButton from "./fill_button";
import { isRoleDisabled } from "./helpers";
import PaginatedExceptionsList from "./paginated_exceptions_list";

const Fill = ({ role, engagement }) => {
  const history = useHistory();

  return (
    <FillButton
      disabled={isRoleDisabled(role)}
      onClick={() =>
        history.push(`/audit_planner/manual_interventions/${engagement.id}/${role.id}/shortlist`)
      }
    />
  );
};

Fill.propTypes = {
  role: PropTypes.object.isRequired,
  engagement: PropTypes.object.isRequired
};

const ManualInterventionsTab = ({
  data,
  fetchData,
  tab,
  fetchAllEngagements,
  workflowAutomation,
  roleFilters
}) => {
  const { current: columns } = useRef([
    {
      header: "",
      cellStyle: { width: "1%" },
      Component: Fill
    }
  ]);

  return (
    <PaginatedExceptionsList
      data={data}
      fetchData={fetchData}
      tab={tab.id}
      columns={columns}
      fetchAllEngagements={fetchAllEngagements}
      workflowAutomation={workflowAutomation}
      roleFilters={roleFilters}
    />
  );
};

ManualInterventionsTab.propTypes = {
  data: PropTypes.shape({
    entries: PropTypes.arrayOf(PropTypes.object),
    meta: PropTypes.object,
    loading: PropTypes.bool
  }),
  tab: PropTypes.object.isRequired,
  fetchData: PropTypes.func.isRequired,
  fetchAllEngagements: PropTypes.func.isRequired,
  workflowAutomation: PropTypes.shape({
    auto_filling: PropTypes.number.isRequired,
    auto_shortlisting: PropTypes.number.isRequired,
    pending: PropTypes.number.isRequired
  }).isRequired,
  roleFilters: PropTypes.object
};

export default ManualInterventionsTab;
